import { render, staticRenderFns } from "./SellerHeader.vue?vue&type=template&id=b4ed4784&"
import script from "./SellerHeader.vue?vue&type=script&lang=ts&"
export * from "./SellerHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SellerHeader.vue?vue&type=style&index=0&id=b4ed4784&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports